import * as TabsPrimitive from "@radix-ui/react-tabs";
import classes from "./Tabs.module.scss";
import { clsx } from "clsx";
import { TabsListProps } from "./TabsListProps";

export function TabsList(props: TabsListProps) {
  const { children, className, align = "center", ...rest } = props;

  const alignClass = {
    start: classes.start,
    center: classes.center,
    end: classes.end,
  }[align];

  return (
    <TabsPrimitive.List
      className={clsx(classes.list, alignClass, className)}
      {...rest}
    >
      {children}
    </TabsPrimitive.List>
  );
}
